"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _image = _interopRequireDefault(require("../image"));
var mapBlogger = function mapBlogger(response) {
  var _response$data$blurha;
  if (!response) return;
  return {
    name: response.data.firstname,
    id: response.id,
    image: (0, _image["default"])(response.data.image, ((_response$data$blurha = response.data.blurhash) === null || _response$data$blurha === void 0 ? void 0 : _response$data$blurha.length) > 0 && response.data.blurhash[0].text),
    url: response.data.profile_link,
    username: response.data.company,
    description: response.data.content && response.data.content.length > 0 && response.data.content[0].text
  };
};
var _default = mapBlogger;
exports["default"] = _default;